import type { IAppSettings } from '../appSettings.types';
import { commonAppSettings } from '../commonAppSettings';

const basename = __BASENAME__ ? `/${__BASENAME__}` : '';

export const devAppSettings: IAppSettings = {
  ...commonAppSettings,
  environment: {
    name: 'dev',
    url: `http://localhost:5173${basename}`,
  },
  enabledRegions: ['crowdaa-dev-us', 'crowdaa-us', 'crowdaa-fr'],
  defaultRegion: 'crowdaa-dev-us',
  analytics: {
    googleTagManager: {
      enabled: false,
      environment: {
        id: 'GTM-PLPTLHXX',
        auth: 'sosQbIx1F1Sk_7X6CpMWkw',
        preview: 'env-9',
      },
    },
    hotjar: {
      enabled: false,
      siteId: '5015493',
    },
    sentry: {
      enabled: false,
      dsn: 'https://dd4d1632fbfc3c21fd4d52cb0fa27202@o4507388908994560.ingest.de.sentry.io/4507388911222864',
    },
  },
  stripe: {
    billingPortalUrl:
      'https://billing.stripe.com/p/login/test_aEUbJdfUE67Redy6op',
  },
  mapBox: {
    accessToken:
      'pk.eyJ1IjoiY3Iwd2Q0NCIsImEiOiJjbTFvdmdmbXcxNzFuMnRzYjRlYWtpbzNiIn0.c9SSKyAkRkOQ3CrcuWEczA',
    styles: {
      light: 'mapbox://styles/mapbox/light-v11',
      dark: 'mapbox://styles/mapbox/dark-v11',
    },
  },
};
